import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const FONTS_URL =
  "https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600&display=swap";

function useFonts() {
  useEffect(() => {
    if (document.querySelector('link[href*="Instrument+Serif"]')) return;
    const l = document.createElement("link");
    l.rel = "stylesheet";
    l.href = FONTS_URL;
    document.head.appendChild(l);
  }, []);
}

const T = {
  g700: "#155c36", g600: "#1b7a47", g500: "#1e9254", g400: "#28b566",
  g200: "#a7d9bc", g100: "#d6f0e3", g50: "#eef8f3",
  n900: "#0f1117", n800: "#1c2130", n700: "#2d3549", n600: "#4a5268",
  n400: "#8a93a8", n300: "#b0b8cc", n200: "#d1d5e0", n150: "#e4e7ef",
  n100: "#eef0f5", n50: "#f7f8fa", white: "#ffffff",
  amber: "#d97706", amberBg: "#fffbeb", amberBorder: "#fde68a", amberText: "#92400e",
  blue: "#2563eb", blueBg: "#eff6ff", blueBorder: "#bfdbfe", blueText: "#1e40af",
  purple: "#7c3aed", purpleBg: "#fdf4ff", purpleBorder: "#e9d5ff", purpleText: "#5b21b6",
  serif: "'Instrument Serif', Georgia, serif",
  sans: "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif",
};

const Icon = ({ name, size = 20, color = "currentColor", strokeWidth = 1.6 }) => {
  const paths = {
    ArrowLeft:     <><path d="M19 12H5"/><path d="m12 19-7-7 7-7"/></>,
    ArrowRight:    <><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></>,
    ChevronRight:  <><path d="m9 18 6-6-6-6"/></>,
    Calendar:      <><rect width="18" height="18" x="3" y="4" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></>,
    MapPin:        <><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z"/><circle cx="12" cy="10" r="3"/></>,
    Monitor:       <><rect width="20" height="14" x="2" y="3" rx="2"/><path d="M8 21h8M12 17v4"/></>,
    Users:         <><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></>,
    Award:         <><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"/></>,
    Zap:           <><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></>,
    Star:          <><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></>,
    Bell:          <><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></>,
    Clock:         <><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></>,
    CheckCircle:   <><circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/></>,
    Mic:           <><path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" x2="12" y1="19" y2="22"/></>,
    Wrench:        <><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></>,
    MessageCircle: <><path d="m3 21 1.9-5.7a8.5 8.5 0 1 1 3.8 3.8z"/></>,
    TrendingUp:    <><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/></>,
    Home:          <><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></>,
    Sparkles:      <><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3z"/></>,
    X:             <><path d="M18 6 6 18"/><path d="m6 6 12 12"/></>,
    Mail:          <><rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></>,
    Globe:         <><circle cx="12" cy="12" r="10"/><path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"/><path d="M2 12h20"/></>,
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
      {paths[name]}
    </svg>
  );
};

/* ─────────────────────────────────────────
   DATA
───────────────────────────────────────── */

const UPCOMING_EVENTS = [
  {
    id: 1,
    type: "online",
    category: "webinar",
    title: "How to hire the right Pro: what to look for before you book",
    description: "A live walkthrough of the JiraniApp platform with our Trust and Safety lead. We cover reading Pro profiles, understanding the verified badge, what reviews actually tell you, and how to write a job description that gets you accurate quotes. Live Q&A at the end.",
    date: "Saturday, 5 July 2026",
    time: "10:00 AM – 11:30 AM EAT",
    location: "Zoom (link sent on registration)",
    audience: ["Clients", "General public"],
    speaker: "JiraniApp Trust & Safety Team",
    spotsTotal: 200,
    spotsLeft: 143,
    tag: "Free",
    tagColor: T.g500,
    tagBg: T.g50,
    tagBorder: T.g100,
    featured: true,
  },
  {
    id: 2,
    type: "in-person",
    category: "workshop",
    title: "JiraniPro Workshop: Building a Profile That Gets Booked",
    description: "A hands-on morning session for service professionals in Nairobi. Bring your phone. We will walk through setting up your profile, uploading portfolio photos, setting pricing, and getting your first five reviews. Breakfast included. Limited to 40 attendees so every participant gets time with the team.",
    date: "Saturday, 19 July 2026",
    time: "8:30 AM – 12:00 PM EAT",
    location: "Nairobi Garage, Westlands, Nairobi",
    audience: ["JiraniPros", "Aspiring Pros"],
    speaker: "JiraniApp Growth Team",
    spotsTotal: 40,
    spotsLeft: 17,
    tag: "Free · Breakfast included",
    tagColor: T.amber,
    tagBg: T.amberBg,
    tagBorder: T.amberBorder,
    featured: true,
  },
  {
    id: 3,
    type: "online",
    category: "qa",
    title: "Live Q&A: Your JiraniApp questions answered",
    description: "An open-format session where anyone — client or Pro — can ask the JiraniApp team anything. No agenda, no slides. Just honest answers to whatever the community wants to know about how the platform works, what is coming next, and how decisions get made.",
    date: "Wednesday, 30 July 2026",
    time: "6:00 PM – 7:00 PM EAT",
    location: "Google Meet (link sent on registration)",
    audience: ["Everyone"],
    speaker: "JiraniApp Founders",
    spotsTotal: 500,
    spotsLeft: 381,
    tag: "Free",
    tagColor: T.g500,
    tagBg: T.g50,
    tagBorder: T.g100,
    featured: false,
  },
  {
    id: 4,
    type: "in-person",
    category: "meetup",
    title: "Mombasa Pro Meetup: Connect, share, grow",
    description: "An informal evening for JiraniPros based on the coast. Meet other professionals in your city, share what is working, talk through challenges, and hear a short update from the JiraniApp team on what is coming for coastal service providers. Drinks and light refreshments provided.",
    date: "Friday, 8 August 2026",
    time: "5:30 PM – 8:00 PM EAT",
    location: "Jahazi Pier, Nyali, Mombasa",
    audience: ["JiraniPros"],
    speaker: "JiraniApp Community Team",
    spotsTotal: 60,
    spotsLeft: 44,
    tag: "Free",
    tagColor: T.g500,
    tagBg: T.g50,
    tagBorder: T.g100,
    featured: false,
  },
];

const COMING_SOON_EVENTS = [
  {
    id: 101,
    type: "in-person",
    category: "awards",
    icon: "Award",
    title: "JiraniPro Awards 2026",
    description: "An evening recognising the best-rated, most-booked, and most-improved JiraniPros across every service category in Kenya. Nominations open to the public.",
    when: "Q4 2026 · Nairobi",
    color: T.amber,
    colorBg: T.amberBg,
    colorBorder: T.amberBorder,
  },
  {
    id: 102,
    type: "online",
    category: "series",
    icon: "TrendingUp",
    title: "Pro Income Series",
    description: "A four-part online workshop series on pricing, rebookings, managing multiple clients, and building a full-time income on JiraniApp. Each session is standalone.",
    when: "August – October 2026 · Online",
    color: T.blue,
    colorBg: T.blueBg,
    colorBorder: T.blueBorder,
  },
  {
    id: 103,
    type: "in-person",
    category: "workshop",
    icon: "Home",
    title: "Home Maintenance Clinic",
    description: "Free half-day clinic for homeowners in Nairobi. JiraniPros from multiple trades walk through what to inspect, what to fix, and how to book the right professional for seasonal maintenance.",
    when: "September 2026 · Nairobi",
    color: T.g500,
    colorBg: T.g50,
    colorBorder: T.g100,
  },
  {
    id: 104,
    type: "online",
    category: "webinar",
    icon: "Mic",
    title: "Client Safety Webinar",
    description: "A short, practical session on how the Jirani Guarantee works, what to do if something goes wrong, and how to use the platform's dispute and review systems confidently.",
    when: "September 2026 · Online",
    color: T.purple,
    colorBg: T.purpleBg,
    colorBorder: T.purpleBorder,
  },
];

const FORMAT_META = {
  online:     { label: "Online",      icon: "Monitor", color: T.blue,   bg: T.blueBg,   border: T.blueBorder   },
  "in-person": { label: "In person",  icon: "MapPin",  color: T.purple, bg: T.purpleBg, border: T.purpleBorder },
};

const CATEGORY_LABELS = {
  webinar:  "Webinar",
  workshop: "Workshop",
  qa:       "Live Q&A",
  meetup:   "Meetup",
  awards:   "Awards",
  series:   "Series",
};

/* ─────────────────────────────────────────
   COMPONENTS
───────────────────────────────────────── */

function FormatBadge({ type }) {
  const m = FORMAT_META[type] || FORMAT_META.online;
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 5,
      fontSize: 11, fontWeight: 600, color: m.color,
      background: m.bg, border: `1px solid ${m.border}`,
      borderRadius: 99, padding: "3px 9px", letterSpacing: "0.03em",
      whiteSpace: "nowrap",
    }}>
      <Icon name={m.icon} size={11} color={m.color} strokeWidth={2.2} />
      {m.label}
    </span>
  );
}

function SpotsMeter({ total, left }) {
  const pct = Math.round(((total - left) / total) * 100);
  const almostFull = left <= Math.ceil(total * 0.25);
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 5, alignItems: "center" }}>
        <span style={{ fontSize: 12, color: almostFull ? T.amber : T.n400, fontWeight: almostFull ? 600 : 400 }}>
          {almostFull ? `Only ${left} spots left` : `${left} spots available`}
        </span>
        <span style={{ fontSize: 11, color: T.n400 }}>{pct}% filled</span>
      </div>
      <div style={{ height: 4, borderRadius: 99, background: T.n100, overflow: "hidden" }}>
        <div style={{
          height: "100%", borderRadius: 99,
          width: `${pct}%`,
          background: almostFull
            ? `linear-gradient(90deg, ${T.amber}, #f59e0b)`
            : `linear-gradient(90deg, ${T.g400}, ${T.g500})`,
          transition: "width .6s cubic-bezier(.4,0,.2,1)",
        }} />
      </div>
    </div>
  );
}

/* Register modal */
function RegisterModal({ event, open, onClose }) {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [focused, setFocused] = useState(null);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  useEffect(() => {
    if (!open) { setSubmitted(false); setEmail(""); setName(""); }
  }, [open]);

  if (!open || !event) return null;

  const handleSubmit = () => {
    if (!name.trim() || !email.trim()) return;
    setSubmitted(true);
  };

  return (
    <div onClick={e => { if (e.target === e.currentTarget) onClose(); }}
      style={{
        position: "fixed", inset: 0, zIndex: 9999,
        background: "rgba(15,17,23,.55)",
        backdropFilter: "blur(6px)", WebkitBackdropFilter: "blur(6px)",
        display: "flex", alignItems: "flex-end", justifyContent: "center",
      }}>
      <style>{`
        @keyframes slideUpModal { from { transform: translateY(28px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
        @media(min-width:600px){ .jrn-modal { border-radius: 20px !important; margin-bottom: 40px !important; } }
      `}</style>
      <div className="jrn-modal" style={{
        background: T.white, width: "100%", maxWidth: 480,
        borderRadius: "20px 20px 0 0", padding: "32px 24px 48px",
        animation: "slideUpModal .24s cubic-bezier(.4,0,.2,1)",
        boxShadow: "0 -4px 40px rgba(0,0,0,.12)",
      }}>
        {/* Close */}
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 20 }}>
          <button onClick={onClose} style={{
            background: T.n50, border: "none", borderRadius: "50%",
            width: 32, height: 32, cursor: "pointer",
            display: "flex", alignItems: "center", justifyContent: "center",
          }}>
            <Icon name="X" size={14} color={T.n600} strokeWidth={2} />
          </button>
        </div>

        {!submitted ? (
          <>
            {/* Event mini-header */}
            <div style={{
              padding: "14px 16px", borderRadius: 12,
              background: T.n50, border: `1px solid ${T.n150}`,
              marginBottom: 24,
            }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
                <FormatBadge type={event.type} />
                <span style={{ fontSize: 11, color: T.n400 }}>{CATEGORY_LABELS[event.category]}</span>
              </div>
              <div style={{ fontFamily: T.serif, fontSize: 16, color: T.n900, letterSpacing: "-0.015em", lineHeight: 1.3 }}>
                {event.title}
              </div>
              <div style={{ fontSize: 12, color: T.n400, marginTop: 6 }}>
                {event.date} · {event.time}
              </div>
            </div>

            <h3 style={{ fontFamily: T.serif, fontSize: 22, fontWeight: 400, color: T.n900, margin: "0 0 6px", letterSpacing: "-0.02em" }}>
              Reserve your spot
            </h3>
            <p style={{ fontSize: 14, color: T.n600, lineHeight: 1.65, margin: "0 0 24px" }}>
              A confirmation and joining link will be sent to your email address.
            </p>

            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              <div>
                <label style={{ fontSize: 12, fontWeight: 600, color: T.n700, display: "block", marginBottom: 6, fontFamily: T.sans }}>
                  Full name
                </label>
                <input value={name} onChange={e => setName(e.target.value)}
                  onFocus={() => setFocused("name")} onBlur={() => setFocused(null)}
                  placeholder="Your name"
                  style={{
                    width: "100%", padding: "12px 14px",
                    border: `1.5px solid ${focused === "name" ? T.g500 : T.n200}`,
                    borderRadius: 10, fontSize: 14, outline: "none",
                    fontFamily: T.sans, color: T.n900, background: T.white,
                    boxShadow: focused === "name" ? `0 0 0 3px ${T.g100}` : "none",
                    transition: "all .18s",
                  }} />
              </div>
              <div>
                <label style={{ fontSize: 12, fontWeight: 600, color: T.n700, display: "block", marginBottom: 6, fontFamily: T.sans }}>
                  Email address
                </label>
                <input value={email} onChange={e => setEmail(e.target.value)}
                  onFocus={() => setFocused("email")} onBlur={() => setFocused(null)}
                  placeholder="you@example.com" type="email"
                  style={{
                    width: "100%", padding: "12px 14px",
                    border: `1.5px solid ${focused === "email" ? T.g500 : T.n200}`,
                    borderRadius: 10, fontSize: 14, outline: "none",
                    fontFamily: T.sans, color: T.n900, background: T.white,
                    boxShadow: focused === "email" ? `0 0 0 3px ${T.g100}` : "none",
                    transition: "all .18s",
                  }} />
              </div>
              <button onClick={handleSubmit}
                disabled={!name.trim() || !email.trim()}
                style={{
                  padding: "13px", background: (!name.trim() || !email.trim()) ? T.n200 : T.g500,
                  color: (!name.trim() || !email.trim()) ? T.n400 : T.white,
                  border: "none", borderRadius: 10, fontSize: 14, fontWeight: 600,
                  cursor: (!name.trim() || !email.trim()) ? "not-allowed" : "pointer",
                  fontFamily: T.sans, transition: "all .18s", marginTop: 4,
                }}
                onMouseEnter={e => { if (name.trim() && email.trim()) e.currentTarget.style.background = T.g600; }}
                onMouseLeave={e => { if (name.trim() && email.trim()) e.currentTarget.style.background = T.g500; }}>
                Reserve my spot — it's free
              </button>
            </div>
            <p style={{ fontSize: 12, color: T.n400, textAlign: "center", margin: "14px 0 0" }}>
              No spam. Just your confirmation and event updates.
            </p>
          </>
        ) : (
          <div style={{ textAlign: "center", padding: "20px 0 10px" }}>
            <div style={{
              width: 56, height: 56, borderRadius: "50%",
              background: T.g50, border: `2px solid ${T.g200}`,
              display: "flex", alignItems: "center", justifyContent: "center",
              margin: "0 auto 20px",
            }}>
              <Icon name="CheckCircle" size={26} color={T.g500} strokeWidth={1.8} />
            </div>
            <h3 style={{ fontFamily: T.serif, fontSize: 24, fontWeight: 400, color: T.n900, margin: "0 0 10px", letterSpacing: "-0.02em" }}>
              You're registered
            </h3>
            <p style={{ fontSize: 14, color: T.n600, lineHeight: 1.7, margin: "0 0 8px" }}>
              A confirmation has been sent to <strong style={{ color: T.n800 }}>{email}</strong>.
            </p>
            <p style={{ fontSize: 13, color: T.n400, lineHeight: 1.65, margin: "0 0 28px" }}>
              {event.type === "online"
                ? "The joining link will be in your confirmation email. We will also send a reminder 24 hours before the event."
                : "Venue details and any preparation notes are in your confirmation email. We look forward to seeing you there."}
            </p>
            <button onClick={onClose} style={{
              padding: "12px 28px", background: T.g500, color: T.white,
              border: "none", borderRadius: 10, fontSize: 14, fontWeight: 600,
              cursor: "pointer", fontFamily: T.sans,
            }}
              onMouseEnter={e => e.currentTarget.style.background = T.g600}
              onMouseLeave={e => e.currentTarget.style.background = T.g500}>
              Done
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

/* Notify modal for coming-soon */
function NotifyModal({ event, open, onClose }) {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  useEffect(() => {
    if (!open) { setSubmitted(false); setEmail(""); }
  }, [open]);

  if (!open || !event) return null;

  return (
    <div onClick={e => { if (e.target === e.currentTarget) onClose(); }}
      style={{
        position: "fixed", inset: 0, zIndex: 9999,
        background: "rgba(15,17,23,.55)",
        backdropFilter: "blur(6px)", WebkitBackdropFilter: "blur(6px)",
        display: "flex", alignItems: "flex-end", justifyContent: "center",
      }}>
      <div className="jrn-modal" style={{
        background: T.white, width: "100%", maxWidth: 440,
        borderRadius: "20px 20px 0 0", padding: "28px 24px 44px",
        animation: "slideUpModal .24s cubic-bezier(.4,0,.2,1)",
        boxShadow: "0 -4px 40px rgba(0,0,0,.12)",
      }}>
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 18 }}>
          <button onClick={onClose} style={{
            background: T.n50, border: "none", borderRadius: "50%",
            width: 32, height: 32, cursor: "pointer",
            display: "flex", alignItems: "center", justifyContent: "center",
          }}>
            <Icon name="X" size={14} color={T.n600} strokeWidth={2} />
          </button>
        </div>

        {!submitted ? (
          <>
            <div style={{
              width: 46, height: 46, borderRadius: 13,
              background: event.colorBg, border: `1.5px solid ${event.colorBorder}`,
              display: "flex", alignItems: "center", justifyContent: "center",
              marginBottom: 18,
            }}>
              <Icon name={event.icon} size={21} color={event.color} strokeWidth={1.6} />
            </div>
            <h3 style={{ fontFamily: T.serif, fontSize: 22, fontWeight: 400, color: T.n900, margin: "0 0 8px", letterSpacing: "-0.02em" }}>
              Get notified when this opens
            </h3>
            <p style={{ fontSize: 14, color: T.n600, lineHeight: 1.7, margin: "0 0 6px" }}>
              <strong style={{ color: T.n800 }}>{event.title}</strong>
            </p>
            <p style={{ fontSize: 13, color: T.n400, lineHeight: 1.65, margin: "0 0 24px" }}>
              {event.when} · We will email you when registration opens.
            </p>
            <input value={email} onChange={e => setEmail(e.target.value)}
              onFocus={() => setFocused(true)} onBlur={() => setFocused(false)}
              placeholder="Your email address" type="email"
              style={{
                width: "100%", padding: "12px 14px", marginBottom: 10,
                border: `1.5px solid ${focused ? T.g500 : T.n200}`,
                borderRadius: 10, fontSize: 14, outline: "none",
                fontFamily: T.sans, color: T.n900,
                boxShadow: focused ? `0 0 0 3px ${T.g100}` : "none",
                transition: "all .18s",
              }} />
            <button onClick={() => { if (email.trim()) setSubmitted(true); }}
              disabled={!email.trim()}
              style={{
                width: "100%", padding: "13px",
                background: !email.trim() ? T.n200 : T.g500,
                color: !email.trim() ? T.n400 : T.white,
                border: "none", borderRadius: 10, fontSize: 14, fontWeight: 600,
                cursor: !email.trim() ? "not-allowed" : "pointer",
                fontFamily: T.sans, transition: "all .18s",
              }}
              onMouseEnter={e => { if (email.trim()) e.currentTarget.style.background = T.g600; }}
              onMouseLeave={e => { if (email.trim()) e.currentTarget.style.background = T.g500; }}>
              Notify me
            </button>
          </>
        ) : (
          <div style={{ textAlign: "center", padding: "10px 0" }}>
            <div style={{
              width: 52, height: 52, borderRadius: "50%",
              background: T.g50, border: `2px solid ${T.g200}`,
              display: "flex", alignItems: "center", justifyContent: "center",
              margin: "0 auto 18px",
            }}>
              <Icon name="Bell" size={24} color={T.g500} strokeWidth={1.8} />
            </div>
            <h3 style={{ fontFamily: T.serif, fontSize: 22, fontWeight: 400, color: T.n900, margin: "0 0 8px", letterSpacing: "-0.02em" }}>
              We will let you know
            </h3>
            <p style={{ fontSize: 14, color: T.n600, lineHeight: 1.65, margin: "0 0 24px" }}>
              As soon as registration opens for <strong style={{ color: T.n800 }}>{event.title}</strong>, you will hear from us at {email}.
            </p>
            <button onClick={onClose} style={{
              padding: "12px 28px", background: T.g500, color: T.white,
              border: "none", borderRadius: 10, fontSize: 14, fontWeight: 600,
              cursor: "pointer", fontFamily: T.sans,
            }}
              onMouseEnter={e => e.currentTarget.style.background = T.g600}
              onMouseLeave={e => e.currentTarget.style.background = T.g500}>
              Done
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

/* Featured event card */
function FeaturedEventCard({ event, onRegister }) {
  const [hovered, setHovered] = useState(false);
  const almostFull = event.spotsLeft <= Math.ceil(event.spotsTotal * 0.25);

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        borderRadius: 18, overflow: "hidden",
        border: `1.5px solid ${hovered ? T.g200 : T.n150}`,
        background: T.white, transition: "border-color .18s, box-shadow .18s",
        boxShadow: hovered ? "0 8px 32px rgba(30,146,84,.08)" : "0 1px 4px rgba(0,0,0,.04)",
      }}>

      {/* Colour strip */}
      <div style={{
        height: 5,
        background: event.type === "online"
          ? `linear-gradient(90deg, ${T.blue}, #60a5fa)`
          : `linear-gradient(90deg, ${T.purple}, #a78bfa)`,
      }} />

      <div style={{ padding: "24px 24px 20px" }}>
        {/* Badges row */}
        <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 16 }}>
          <FormatBadge type={event.type} />
          <span style={{ fontSize: 11, color: T.n400, fontWeight: 500 }}>
            {CATEGORY_LABELS[event.category]}
          </span>
          <span style={{
            marginLeft: "auto", fontSize: 11, fontWeight: 700,
            color: event.tagColor, background: event.tagBg,
            border: `1px solid ${event.tagBorder}`,
            borderRadius: 99, padding: "3px 10px",
          }}>{event.tag}</span>
        </div>

        <h3 style={{
          fontFamily: T.serif, fontSize: "clamp(19px,3vw,24px)", fontWeight: 400,
          color: T.n900, margin: "0 0 10px", letterSpacing: "-0.02em", lineHeight: 1.25,
        }}>
          {event.title}
        </h3>
        <p style={{ fontSize: 14, color: T.n600, lineHeight: 1.75, margin: "0 0 20px" }}>
          {event.description}
        </p>

        {/* Meta grid */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 20 }}>
          {[
            { icon: "Calendar", label: event.date },
            { icon: "Clock",    label: event.time },
            { icon: event.type === "online" ? "Monitor" : "MapPin", label: event.location },
            { icon: "Mic",      label: event.speaker },
          ].map((m, i) => (
            <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
              <span style={{ marginTop: 1, flexShrink: 0 }}>
                <Icon name={m.icon} size={13} color={T.n400} strokeWidth={1.8} />
              </span>
              <span style={{ fontSize: 12, color: T.n600, lineHeight: 1.5 }}>{m.label}</span>
            </div>
          ))}
        </div>

        {/* Audience pills */}
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 20 }}>
          <span style={{ fontSize: 11, color: T.n400 }}>For:</span>
          {event.audience.map((a, i) => (
            <span key={i} style={{
              fontSize: 11, fontWeight: 600, color: T.g600,
              background: T.g50, border: `1px solid ${T.g100}`,
              borderRadius: 99, padding: "2px 8px",
            }}>{a}</span>
          ))}
        </div>

        {/* Spots meter */}
        <div style={{ marginBottom: 20 }}>
          <SpotsMeter total={event.spotsTotal} left={event.spotsLeft} />
        </div>

        {/* CTA */}
        <button onClick={() => onRegister(event)} style={{
          width: "100%", padding: "13px", background: T.g500, color: T.white,
          border: "none", borderRadius: 11, fontSize: 14, fontWeight: 600,
          cursor: "pointer", fontFamily: T.sans, letterSpacing: "0.01em",
          display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
          transition: "background .15s",
        }}
          onMouseEnter={e => e.currentTarget.style.background = T.g600}
          onMouseLeave={e => e.currentTarget.style.background = T.g500}>
          Register — it's free
          <Icon name="ArrowRight" size={15} color={T.white} strokeWidth={2} />
        </button>
      </div>
    </div>
  );
}

/* Standard event card */
function EventCard({ event, onRegister }) {
  const almostFull = event.spotsLeft <= Math.ceil(event.spotsTotal * 0.25);
  return (
    <div style={{
      borderRadius: 14, border: `1px solid ${T.n150}`,
      background: T.white, overflow: "hidden",
      transition: "border-color .15s",
    }}
      onMouseEnter={e => e.currentTarget.style.borderColor = T.n200}
      onMouseLeave={e => e.currentTarget.style.borderColor = T.n150}>

      {/* Thin left accent */}
      <div style={{ display: "flex" }}>
        <div style={{
          width: 4, flexShrink: 0,
          background: event.type === "online"
            ? `linear-gradient(180deg, ${T.blue}, #60a5fa)`
            : `linear-gradient(180deg, ${T.purple}, #a78bfa)`,
        }} />
        <div style={{ flex: 1, padding: "20px 20px 20px 18px" }}>
          <div style={{ display: "flex", alignItems: "flex-start", gap: 10, marginBottom: 12 }}>
            <div style={{ flex: 1 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 7, marginBottom: 8, flexWrap: "wrap" }}>
                <FormatBadge type={event.type} />
                <span style={{ fontSize: 11, color: T.n400 }}>{CATEGORY_LABELS[event.category]}</span>
                <span style={{
                  marginLeft: "auto", fontSize: 11, fontWeight: 700,
                  color: event.tagColor, background: event.tagBg,
                  border: `1px solid ${event.tagBorder}`,
                  borderRadius: 99, padding: "2px 8px",
                }}>{event.tag}</span>
              </div>
              <h4 style={{
                fontFamily: T.serif, fontSize: "clamp(16px,2.5vw,19px)", fontWeight: 400,
                color: T.n900, margin: "0 0 8px", letterSpacing: "-0.015em", lineHeight: 1.3,
              }}>{event.title}</h4>
              <p style={{ fontSize: 13, color: T.n600, lineHeight: 1.7, margin: "0 0 14px" }}>{event.description}</p>
            </div>
          </div>

          {/* Meta row */}
          <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginBottom: 14 }}>
            {[
              { icon: "Calendar", label: event.date },
              { icon: "Clock",    label: event.time },
              { icon: event.type === "online" ? "Globe" : "MapPin", label: event.location },
            ].map((m, i) => (
              <div key={i} style={{ display: "flex", alignItems: "center", gap: 5 }}>
                <Icon name={m.icon} size={12} color={T.n400} strokeWidth={1.8} />
                <span style={{ fontSize: 12, color: T.n500 }}>{m.label}</span>
              </div>
            ))}
          </div>

          {/* Spots + CTA row */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16, flexWrap: "wrap" }}>
            <div style={{ flex: 1, minWidth: 160 }}>
              <SpotsMeter total={event.spotsTotal} left={event.spotsLeft} />
            </div>
            <button onClick={() => onRegister(event)} style={{
              display: "inline-flex", alignItems: "center", gap: 6,
              padding: "10px 20px", background: T.g500, color: T.white,
              border: "none", borderRadius: 9, fontSize: 13, fontWeight: 600,
              cursor: "pointer", fontFamily: T.sans, flexShrink: 0,
              transition: "background .15s",
            }}
              onMouseEnter={e => e.currentTarget.style.background = T.g600}
              onMouseLeave={e => e.currentTarget.style.background = T.g500}>
              Register
              <Icon name="ArrowRight" size={13} color={T.white} strokeWidth={2.2} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

/* Coming-soon card */
function ComingSoonCard({ event, onNotify }) {
  return (
    <div style={{
      borderRadius: 14, border: `1.5px dashed ${event.colorBorder}`,
      background: event.colorBg, padding: "20px",
      transition: "border-color .15s",
    }}>
      <div style={{
        width: 40, height: 40, borderRadius: 11,
        background: T.white, border: `1px solid ${event.colorBorder}`,
        display: "flex", alignItems: "center", justifyContent: "center",
        marginBottom: 14,
      }}>
        <Icon name={event.icon} size={18} color={event.color} strokeWidth={1.7} />
      </div>
      <div style={{ fontSize: 11, fontWeight: 700, color: event.color, letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: 6 }}>
        Coming soon
      </div>
      <h4 style={{
        fontFamily: T.serif, fontSize: "clamp(15px,2.5vw,18px)", fontWeight: 400,
        color: T.n900, margin: "0 0 8px", letterSpacing: "-0.015em", lineHeight: 1.3,
      }}>{event.title}</h4>
      <p style={{ fontSize: 13, color: T.n600, lineHeight: 1.7, margin: "0 0 14px" }}>{event.description}</p>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, flexWrap: "wrap" }}>
        <span style={{ fontSize: 12, color: event.color, fontWeight: 500 }}>{event.when}</span>
        <button onClick={() => onNotify(event)} style={{
          display: "inline-flex", alignItems: "center", gap: 5,
          padding: "8px 14px", background: "transparent",
          color: event.color, border: `1.5px solid ${event.colorBorder}`,
          borderRadius: 8, fontSize: 12, fontWeight: 600,
          cursor: "pointer", fontFamily: T.sans, transition: "all .15s",
        }}
          onMouseEnter={e => { e.currentTarget.style.background = T.white; }}
          onMouseLeave={e => { e.currentTarget.style.background = "transparent"; }}>
          <Icon name="Bell" size={12} color={event.color} strokeWidth={2.2} />
          Notify me
        </button>
      </div>
    </div>
  );
}

/* ══ MAIN PAGE ══ */
export default function EventsPage() {
  useFonts();
  const navigate = useNavigate();

  const [registerEvent, setRegisterEvent] = useState(null);
  const [notifyEvent, setNotifyEvent]     = useState(null);

  const featured = UPCOMING_EVENTS.filter(e => e.featured);
  const standard = UPCOMING_EVENTS.filter(e => !e.featured);

  return (
    <div style={{ fontFamily: T.sans, background: T.white, minHeight: "100vh", color: T.n900, paddingBottom: 100 }}>
      <style>{`
        * { box-sizing: border-box; }
        ::-webkit-scrollbar { display: none; }
        @keyframes slideUpModal { from { transform: translateY(28px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
        @media(min-width:600px){ .jrn-modal { border-radius: 20px !important; margin-bottom: 40px !important; } }
      `}</style>

      {/* ── Nav ── */}
      <div style={{ padding: "16px 24px", borderBottom: `1px solid ${T.n100}`, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <button onClick={() => navigate(-1)} style={{
          display: "inline-flex", alignItems: "center", gap: 6,
          background: "none", border: "none", cursor: "pointer",
          color: T.n400, fontSize: 13, fontFamily: T.sans, padding: 0,
        }}
          onMouseEnter={e => e.currentTarget.style.color = T.n800}
          onMouseLeave={e => e.currentTarget.style.color = T.n400}>
          <Icon name="ArrowLeft" size={14} strokeWidth={2} />
          Back
        </button>
        <button onClick={() => navigate("/signup")} style={{
          display: "inline-flex", alignItems: "center", gap: 6,
          background: T.g500, border: "none", cursor: "pointer",
          color: T.white, fontSize: 13, fontFamily: T.sans,
          padding: "8px 16px", borderRadius: 8, fontWeight: 600,
        }}
          onMouseEnter={e => e.currentTarget.style.background = T.g600}
          onMouseLeave={e => e.currentTarget.style.background = T.g500}>
          Join JiraniApp free
          <Icon name="ArrowRight" size={13} strokeWidth={2.2} color={T.white} />
        </button>
      </div>

      {/* ══ HERO ══ */}
      <div style={{ padding: "clamp(52px,7vw,88px) 20px clamp(44px,6vw,64px)", borderBottom: `1px solid ${T.n100}` }}>
        <div style={{ maxWidth: 720, margin: "0 auto" }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 8, color: T.g600, fontSize: 12, fontWeight: 600, letterSpacing: "0.09em", textTransform: "uppercase", marginBottom: 22 }}>
            <Icon name="Calendar" size={13} color={T.g500} strokeWidth={2.2} />
            Events
          </div>
          <h1 style={{
            fontFamily: T.serif, fontSize: "clamp(38px,7vw,66px)", fontWeight: 400,
            margin: "0 0 18px", lineHeight: 1.06, color: T.n900,
            letterSpacing: "-0.03em", maxWidth: 620,
          }}>
            Learn, connect, and<br/>
            <em style={{ fontStyle: "italic", color: T.g600 }}>grow with JiraniApp</em>
          </h1>
          <p style={{ fontSize: "clamp(15px,2vw,17px)", color: T.n600, lineHeight: 1.75, margin: "0 0 28px", maxWidth: 520 }}>
            Free online sessions and in-person meetups across Kenya for clients,
            professionals, and anyone curious about how JiraniApp works.
            All events are free. All seats are limited.
          </p>

          {/* Format legend */}
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
            {Object.entries(FORMAT_META).map(([key, m]) => (
              <div key={key} style={{ display: "inline-flex", alignItems: "center", gap: 7 }}>
                <span style={{
                  display: "inline-flex", alignItems: "center", gap: 5,
                  fontSize: 12, fontWeight: 500, color: m.color,
                  background: m.bg, border: `1px solid ${m.border}`,
                  borderRadius: 99, padding: "4px 11px",
                }}>
                  <Icon name={m.icon} size={12} color={m.color} strokeWidth={2} />
                  {m.label}
                </span>
              </div>
            ))}
            <span style={{ fontSize: 13, color: T.n400, display: "flex", alignItems: "center" }}>
              · {UPCOMING_EVENTS.length} upcoming events
            </span>
          </div>
        </div>
      </div>

      {/* ══ TRUST STRIP ══ */}
      <div style={{ borderBottom: `1px solid ${T.n100}`, padding: "0 20px" }}>
        <div style={{ maxWidth: 720, margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))" }}>
          {[
            { icon: "Star",    label: "Every event is free to attend" },
            { icon: "Users",   label: "Open to clients, Pros, and the public" },
            { icon: "Sparkles",label: "Hosted by the JiraniApp team" },
          ].map(({ icon, label }, i) => (
            <div key={i} style={{ padding: "20px", display: "flex", alignItems: "center", gap: 11, borderRight: i < 2 ? `1px solid ${T.n100}` : "none" }}>
              <Icon name={icon} size={17} color={T.g500} strokeWidth={1.6} />
              <span style={{ fontSize: 13, color: T.n600, lineHeight: 1.4 }}>{label}</span>
            </div>
          ))}
        </div>
      </div>

      <div style={{ maxWidth: 720, margin: "0 auto", padding: "0 20px" }}>

        {/* ══ FEATURED EVENTS ══ */}
        <div style={{ paddingTop: "clamp(44px,6vw,64px)", marginBottom: "clamp(40px,6vw,56px)" }}>
          <p style={{ fontSize: 11, fontWeight: 700, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>
            Featured events
          </p>
          <h2 style={{
            fontFamily: T.serif, fontSize: "clamp(26px,4.5vw,36px)", fontWeight: 400,
            color: T.n900, margin: "0 0 8px", letterSpacing: "-0.03em", lineHeight: 1.15,
          }}>
            Up next from <em style={{ fontStyle: "italic", color: T.g600 }}>JiraniApp</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 0 28px", lineHeight: 1.65 }}>
            Reserve your spot — all events fill up. Registration takes under a minute.
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: 16 }}>
            {featured.map(e => (
              <FeaturedEventCard key={e.id} event={e} onRegister={setRegisterEvent} />
            ))}
          </div>
        </div>

        {/* ══ MORE UPCOMING ══ */}
        <div style={{ marginBottom: "clamp(44px,6vw,64px)" }}>
          <p style={{ fontSize: 11, fontWeight: 700, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>
            More upcoming
          </p>
          <h2 style={{
            fontFamily: T.serif, fontSize: "clamp(24px,4vw,32px)", fontWeight: 400,
            color: T.n900, margin: "0 0 24px", letterSpacing: "-0.03em", lineHeight: 1.2,
          }}>
            Also on the <em style={{ fontStyle: "italic", color: T.g600 }}>calendar</em>
          </h2>
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            {standard.map(e => (
              <EventCard key={e.id} event={e} onRegister={setRegisterEvent} />
            ))}
          </div>
        </div>

        {/* ══ COMING SOON ══ */}
        <div style={{ marginBottom: "clamp(44px,6vw,64px)" }}>
          <p style={{ fontSize: 11, fontWeight: 700, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>
            Coming soon
          </p>
          <h2 style={{
            fontFamily: T.serif, fontSize: "clamp(24px,4vw,32px)", fontWeight: 400,
            color: T.n900, margin: "0 0 8px", letterSpacing: "-0.03em", lineHeight: 1.2,
          }}>
            What's coming <em style={{ fontStyle: "italic", color: T.g600 }}>later this year</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 0 24px", lineHeight: 1.65 }}>
            Registration is not open yet but you can ask us to notify you the moment it does.
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: 14 }}>
            {COMING_SOON_EVENTS.map(e => (
              <ComingSoonCard key={e.id} event={e} onNotify={setNotifyEvent} />
            ))}
          </div>
        </div>

        {/* ══ SUGGEST AN EVENT ══ */}
        <div style={{
          marginBottom: "clamp(44px,6vw,64px)",
          padding: "clamp(28px,4vw,40px) clamp(20px,4vw,36px)",
          borderRadius: 18, border: `1px solid ${T.n150}`,
          background: T.n50, display: "flex", gap: 20,
          alignItems: "flex-start", flexWrap: "wrap",
        }}>
          <div style={{
            width: 48, height: 48, borderRadius: 13,
            background: T.white, border: `1.5px solid ${T.n150}`,
            display: "flex", alignItems: "center", justifyContent: "center",
            flexShrink: 0,
          }}>
            <Icon name="MessageCircle" size={21} color={T.n400} strokeWidth={1.6} />
          </div>
          <div style={{ flex: 1, minWidth: 220 }}>
            <h3 style={{
              fontFamily: T.serif, fontSize: "clamp(18px,3vw,22px)", fontWeight: 400,
              color: T.n900, margin: "0 0 8px", letterSpacing: "-0.02em", lineHeight: 1.3,
            }}>
              Have a topic or session idea?
            </h3>
            <p style={{ fontSize: 14, color: T.n600, lineHeight: 1.7, margin: "0 0 16px" }}>
              If there is something you want the JiraniApp team to cover in a future session
              — a pricing question, a safety topic, a skills workshop — we want to hear it.
              Most of our best event ideas come directly from the community.
            </p>
            <button onClick={() => navigate("/help")} style={{
              display: "inline-flex", alignItems: "center", gap: 7,
              padding: "10px 20px", background: T.white, color: T.n700,
              border: `1.5px solid ${T.n200}`, borderRadius: 9,
              fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: T.sans,
              transition: "border-color .15s",
            }}
              onMouseEnter={e => e.currentTarget.style.borderColor = T.n400}
              onMouseLeave={e => e.currentTarget.style.borderColor = T.n200}>
              Send us a suggestion
              <Icon name="ChevronRight" size={14} strokeWidth={2.5} color={T.n400} />
            </button>
          </div>
        </div>

        {/* ══ FOOTER CTA ══ */}
        <div style={{
          padding: "clamp(36px,5vw,52px)", borderRadius: 20,
          border: `1px solid ${T.n150}`, textAlign: "center",
          background: T.n50, marginBottom: 20,
        }}>
          <div style={{
            width: 50, height: 50, borderRadius: 14, background: T.g50,
            border: `1.5px solid ${T.g200}`,
            display: "flex", alignItems: "center", justifyContent: "center",
            margin: "0 auto 18px",
          }}>
            <Icon name="Bell" size={22} color={T.g500} strokeWidth={1.6} />
          </div>
          <h2 style={{
            fontFamily: T.serif, fontSize: "clamp(26px,4vw,36px)", fontWeight: 400,
            color: T.n900, margin: "0 0 10px", letterSpacing: "-0.03em", lineHeight: 1.2,
          }}>
            Never miss an event
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 auto 28px", lineHeight: 1.75, maxWidth: 400 }}>
            Create a free JiraniApp account and we will notify you when new events are announced.
            No spam — just event updates.
          </p>
          <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
            <button onClick={() => navigate("/signup")} style={{
              padding: "13px 28px", background: T.g500, color: T.white,
              border: "none", borderRadius: 11, fontSize: 14, fontWeight: 600,
              fontFamily: T.sans, cursor: "pointer", letterSpacing: "0.01em",
              display: "inline-flex", alignItems: "center", gap: 8,
            }}
              onMouseEnter={e => e.currentTarget.style.background = T.g600}
              onMouseLeave={e => e.currentTarget.style.background = T.g500}>
              Create a free account
              <Icon name="ArrowRight" size={15} color={T.white} strokeWidth={2} />
            </button>
            <button onClick={() => navigate("/community")} style={{
              padding: "13px 24px", background: "transparent", color: T.n700,
              border: `1.5px solid ${T.n200}`, borderRadius: 11, fontSize: 14, fontWeight: 600,
              fontFamily: T.sans, cursor: "pointer",
            }}
              onMouseEnter={e => e.currentTarget.style.borderColor = T.n400}
              onMouseLeave={e => e.currentTarget.style.borderColor = T.n200}>
              Visit Community Hub
            </button>
          </div>
        </div>

      </div>

      {/* ── Modals ── */}
      <RegisterModal
        event={registerEvent}
        open={!!registerEvent}
        onClose={() => setRegisterEvent(null)}
      />
      <NotifyModal
        event={notifyEvent}
        open={!!notifyEvent}
        onClose={() => setNotifyEvent(null)}
      />
    </div>
  );
}